export default {
    FORMULA: 1,
    LISTA: 2,
    NUMERICO: 3,
    TEXTO: 4,
    TEXTOENUMERO: 5,
    CAIXA_TEXTO: 6,
}